import React from "react";
import { array, bool } from "prop-types";

import CustomStoryCard2 from "../../../molecules/CustomStoryCard2";

import "./organism2.m.css";

const Organism2 = ({ stories, updatedFont }) => {
  if (!(stories && stories.length)) {
    return null;
  }

  return (
    <div styleName="wrapper">
      {stories.map((story, index) => (
        <CustomStoryCard2
          story={story.story}
          key={index}
          headlineType={4}
          subHeadlineType={6}
          isImageCaptionRequired={false}
          isSection={false}
          widths={[200]}
          isExcerpt={true}
          updatedFont={updatedFont}
          isSmallCard={true}
          src="six-story-with-poll"
          updateSubHeadline={true}
        />
      ))}
    </div>
  );
};

Organism2.propTypes = {
  stories: array.isRequired,
  updatedFont: bool
};

export default Organism2;
